<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { api } from '../../api/Api'
import { toBool } from '../../utils/CommonFunctions'
import { Settings } from '../../types/models'
import TextInput from '../../components/ui/form/TextInput.vue'
import AmountInput from '../../components/ui/form/AmountInput.vue'
import CheckInput from '../../components/ui/form/CheckInput.vue'
import Toast from '../../services/Toast'
import IconComponent from '../../components/ui/common/IconComponent.vue'

const title =  ref("Settings");

const emit = defineEmits<{
  (e: "next"): void;
  (e: "skip"): void;
}>();

const props = defineProps<{
  section: string,
}>()

const activeSetting = ref<Settings>()
const settings = ref<Settings[]>([])
async function getSettings() {
  const response = await api.post(
    "system/company/settings/get"
  );
  if (response.success == true) {
    let set: Settings[] = response.data as Settings[]
    set.forEach(sec => {
      sec.sub_section?.forEach ( (sub) => {
        sub.settings?.forEach((setting) => {
          if (setting.field_type == 'number') {
            setting.value = parseInt(setting.value as string || '0')
          } else if (setting.field_type == 'check') {
            setting.value = toBool(setting.value || false)
          }
        });
      })
    });
    settings.value = set
    activeSetting.value = set.find((e) => e.name == props.section)
    title.value = activeSetting.value?.caption || "Settings"
  }
}

const getSelectItems = (text: string): string[] => {
  return [...new Set(text.split(",").map(item => item.trim()))];
}


const handleSubmit = async () => {
    const params = {
    'settings': settings.value
  }
  const response = await api.post(
    "system/company/settings/update", params
  );
    if (response.success == true) {
      Toast.show("saved successfully");
      emit("next");
    }
};

const isLoading = ref(false);

onMounted(() => {
  getSettings()  
})

</script>

<template>
    <div
    class="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 w-full self-start relative"
  >
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-xl font-semibold">{{ title }}</h3>
    <button
    @click="handleSubmit"
      class="px-2 md:px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 rounded hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center justify-center"
    >
      <IconComponent name="CircleArrowRight" />
      <span class="ml-2 uppercase tracking-wide">Next</span>
    </button>
    </div>
    <div
      v-if="isLoading"
      class="absolute top-0 left-0 w-full h-full bg-blue-500 bg-opacity-50 flex items-center justify-center animate-blink"
    >
      <div
        class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 animate-spin"
      ></div>
    </div>
    <div v-else>
        <hr />
        <div class="p-6">
        <div class="space-y-6" v-if="activeSetting">
        <div class="grid grid-cols-1 gap-6" v-for="section in activeSetting.sub_section">
          <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {{ section.caption }}
          </label>
          </div>
          <div class="grid md:grid-cols-2 gap-6">
          <div v-for="key in section.settings">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {{key.caption}}
            </label>
            <TextInput v-if="key.field_type === 'text'" v-model="key.value" label="" />
            <TextInput v-if="key.field_type === 'password'" v-model="key.value" label="" type="password"/>
            <AmountInput v-if="key.field_type == 'number'" v-model="key.value" label="" />

            <select
            v-if="key.field_type == 'list'"
            v-model="key.value"
            class="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            >
            <option v-for="item in getSelectItems(key.extra_values || '')" :key="item" :value="item">{{ item }}</option>
            </select>

            <!--<SearchSelect
            label=""
            v-if="key.field_type == 'db_list'"
            :end-point="key.extra_values"
            v-model="key.value"
            TODO: fix this later
            />--> 

            <CheckInput v-if="key.field_type == 'check'" v-model="key.value" label="" />
            
          </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    </div>
</template>